import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'adaptiveColor',
    standalone: true,
})
export class AdaptiveColorPipe implements PipeTransform {
    transform (bgColor?: string): string {
        if (!bgColor || !/^#([A-Fa-f0-9]{6})$/.test(bgColor)) {
            return '#000000';
        }

        const background = this.getLuminance(bgColor);
        const foreground = this.getLuminance('#000000');
        const ratio = (background + 0.05) / (foreground + 0.05); // ratio between foreground and background luminance
        if (ratio >= 4.5) {
            return '#000000'; // ratio needs to be at least 4.5 according to WCAG 2.0 level AA
        }
        return '#FFFFFF';
    }

    getRGB (clr: string) {
        const colorDecimal = parseInt(clr, 16) / 255;
        if (colorDecimal <= 0.03928) {
            return colorDecimal / 12.92;
        } else {
            return Math.pow(((colorDecimal + 0.055) / 1.055), 2.4);
        }
    }

    getLuminance (hexColor: string) {
        return (0.2126 * this.getRGB(hexColor.slice(1, 3)) + 0.7152 * this.getRGB(hexColor.slice(3, 5)) + 0.0722 * this.getRGB(hexColor.slice(-2)));
    }
}
